<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9HHrUM/tc-custom/9781250108937.jpg?1731166637883" alt="This image is the cover for the book 83 Minutes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">83 Minutes
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A definitive look at Michael Jackson's final minutes, revealing for the first time the shocking details behind the tragic death of one of the world's biggest pop stars.</b><br/><br/>On June 25th, 2009, the world was rocked by the tragic news that Michael Jackson—the biggest and most influential music icon since Elvis Presley—had died. He was only 50 years old when paramedics pronounced him dead on arrival at a Los Angeles hospital. For weeks after his death, speculation and rumor abounded concerning the drugs in Jackson’s system and the role Conrad Murray, the singer’s personal physician, had played in the his death. In 2011, Murray was tried and convicted of involuntary manslaughter, for which he served two years in prison.<br/><br/>Now, for the first time, readers have access to a comprehensive and truly horrifying account of the crucial moments leading up to Jackson’s demise. Drawing on court documents and testimonials, <i>83 Minutes</i> presents a multi-perspective tracking of every individual involved and the part they played as the tragedy unfolded, examining forensically the mystery of the 83 minutes that elapsed from the moment Dr. Murray suggested he found Jackson not breathing to the moment the singers' lifeless body was wheeled into hospital.<br/><br/>Evenhanded and unbiased, Matt Richards and Mark Langthorne’s account is rich with detail, including the specific cocktail of drugs employed in an attempt to keep Jackson alive and the harrowing conditions in which the troubled genius’s life ended. Included as well is the story of the legal struggle for control of Jackson’s assets that followed his death where Richards and Langthorne report that “the combined earnings of Jay Z, Taylor Swift, and Kanye West since Michael Jackson died come nowhere near the revenues Jackson has earned for his estate after his death.”<br/><br/>Written with documentary flair, this powerful and compelling book is already emerging as the definitive account of one of the darkest hours in music history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matt Richards, Mark Langthorne
      </h2>
      
      <p class="authorDescription body article"><P>Matt Richards is an award-winning film director, television producer and screenwriter who has written and directed numerous documentaries and series in the UK and the U.S.<br><br>Mark Langthorne is CEO of Roland Mouret and has previously worked in the music industry with such stars as Kanye West, Marc Almond and Annie Lennox.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0b5f5bd3